import styled from "styled-components";

export const StyledBoxContainer = styled.div<{
  $borderColor?: string;
  $borderWidth?: number;
}>`
  border: ${(props) =>
    props.$borderWidth === 0
      ? "none"
      : (props.$borderWidth &&
        props.$borderWidth > 0 &&
        props.$borderWidth <= 10
          ? props.$borderWidth + "px solid "
          : "5px solid ") +
        (props.$borderColor
          ? "var(--" + props.$borderColor + ")"
          : "var(--ons-color-info-tint)")};
  height: auto;
  display: flex;
  flex-direction: column;
  min-width: fit-content;
`;

export const StyledBoxContent = styled.div``;

export const StyledBoxHeader = styled.div<{
  $borderColor?: string;
  $titleColor?: string;
}>`
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: ${(props) =>
    props.$borderColor ? "var(--" + props.$borderColor + ")" : ""};
  ${(props) => props.$titleColor && `color: var(--${props.$titleColor})`}
`;
